module.exports = __webpack_public_path__ + "img/ttf.81d758cb.svg";